import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputGroup from '../../input-group';
import keyCodes from '../../../constants/key-codes';

const DEFAULT_ARROW_OFFSET = 1;

const VALID_KEY_CODES = [keyCodes.UP, keyCodes.DOWN];

const isValidKeyCode = (keyCode) => VALID_KEY_CODES.indexOf(keyCode) > -1;
const stringifyValue = (value) => String(value).toUpperCase();

const ColorInput = ({
  onChange,
  name,
  value,
  min = '',
  max = '',
  isValuePercent = false,
  align = 'center',
}) => {
  const [inputValue, setInputValue] = useState(stringifyValue(value));
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (updatedValue) => {
    let newValue = !Number.isNaN(parseInt(updatedValue, 10))
      ? parseInt(updatedValue, 10)
      : updatedValue;

    if (min && newValue < min) {
      newValue = min;
    }

    if (max && newValue > max) {
      newValue = max;
    }

    setInputValue(`${stringifyValue(newValue)}${isValuePercent ? '%' : ''}`);
    onChange({ [name]: newValue });
  };

  const onBlur = () => {
    const stringifiedValue = stringifyValue(value);

    if (inputValue !== stringifiedValue) {
      setInputValue(stringifiedValue);
    }

    setIsFocused(false);
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  const onKeyDown = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!Number.isNaN(newValue) && isValidKeyCode(e.keyCode)) {
      const updatedValue =
        e.keyCode === keyCodes.UP
          ? newValue + DEFAULT_ARROW_OFFSET
          : newValue - DEFAULT_ARROW_OFFSET;

      handleChange(updatedValue);
    }
  };

  useEffect(() => {
    const stringifiedValue = stringifyValue(value);

    if (stringifiedValue !== inputValue && !isFocused) {
      setInputValue(stringifiedValue);
    }
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, [value]);

  return (
    <InputGroup
      value={inputValue}
      align={align}
      onChange={handleChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
    />
  );
};

ColorInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  align: PropTypes.string,
  isValuePercent: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default ColorInput;
